import type { Page } from '../../types';

const trialRequest: Page[] = [
  {
    pageType: 'question',
    title: 'LLM request',
    name: 'requirements',
    description:
      'Tell us what you want to test, the benefit you expect and the monthly budget your team could commit.',
    questions: [
      {
        questionType: 'select',
        title: 'Which AI model family would you prefer?',
        name: 'preferred-llm-model',
        hintOption: 'Select a model family',
        options: [
          'Anthropic Claude',
          'OpenAI GPT',
          'Google Gemma',
          'Amazon Nova',
          'Meta Llama',
          'Mistral AI',
          'DeepSeek',
          'No preference / not sure',
          {
            option: 'Other',
            questions: [
              {
                questionType: 'textInput',
                title: 'Other - please specify:',
                name: 'other-preferred-llm-model',
                rules: {
                  required: true,
                },
              },
            ],
          },
        ],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title: 'What will be your main use for the LLM model?',
        name: 'main-use-case',
        options: ['AI features within an application', 'Coding assistant', 'Other'],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'How will you use the LLM and what is the benefit?',
        name: 'llm-use-and-benefit',
        hint: 'Describe the problem, who will use it and the result you expect. Do not include personal, sensitive or classified information.',
        textRows: 8,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInputSmall',
        title: 'How many user licences do you require?',
        name: 'number-of-user-licences',
        hint: 'If completing this form only for yourself, enter 1',
        rules: {
          required: true,
        },
        errorMessages: {
          required: 'This field is required',
        },
      },
      {
        questionType: 'textInput',
        title: 'Estimated monthly budget for LLM use (£)',
        name: 'estimated-monthly-budget',
        width: 'one-quarter',
        hint:
          'Enter the amount your team could commit each month, excluding VAT.  \n' +
          'This is an estimate and is not a commitment to spend.',
        rules: {
          required: true,
          number: true,
          min: 1,
        },
        errorMessages: {
          min: 'Monthly budget must be £1 or more',
        },
      },
    ],
  },
];

export default trialRequest;
